import {
  BusinessDecision,
  BusinessDecisionInput,
} from "../../../interfaces/AdminApprovalObject";

/**
 * UI decision -> POST /api/v1/user/businesses/decision body.
 *
 * Two rules live here rather than at the call sites:
 *  - `rejectionReason` is sent ONLY with a REJECTED decision. Sending a reason
 *    alongside an approval would persist a misleading audit trail.
 *  - a REJECTED decision without a reason is refused client-side: the reason is
 *    stored on the row and shown back to the submitting captain, so an empty
 *    one makes the rejection unexplainable after the fact.
 */
export function buildBusinessDecisionPayload(input: BusinessDecisionInput): {
  pendingId: string;
  decision: BusinessDecision;
  rejectionReason?: string;
} {
  const reason = input.rejectionReason?.trim();

  if (input.decision === BusinessDecision.REJECTED && !reason) {
    throw new Error("A rejection reason is required.");
  }

  return {
    pendingId: input.pendingId,
    decision: input.decision,
    ...(input.decision === BusinessDecision.REJECTED
      ? { rejectionReason: reason }
      : {}),
  };
}
